// AUD-T2b (28/10/2026) -- /comecar, a pagina que o anuncio aponta.
//
// POR QUE UMA PAGINA NOVA E NAO A LANDING
// O endereco de destino do anuncio e seu. A landing continua INTOCADA, e
// da para comparar as duas com dado real. Se esta converter melhor, ai sim
// muda o botao da landing -- com numero, nao com palpite.
//
// NENHUM PRECO ESCRITO AQUI DENTRO
// Tudo que aparece na tela vem de GET /api/v1/config/planos, que o painel
// admin grava (AUD-T2a) e que e publico de proposito (ver
// _TENANT_SCOPED_PREFIXES em tenant-service/src/routes/config.py: a chave
// "planos" fica fora da lista, entao e legivel sem token).
//
// E se a config nao vier, ou vier sem preco valido, a pagina diz
// "consulte" e oferece falar com a gente. NUNCA um preco inventado: preco
// errado na tela e pior que preco ausente.
//
// A SESSAO NAO E MONTADA AQUI
// Depois do cadastro, esta pagina chama a login() de store/auth.js -- a
// MESMA funcao do login normal. Ela grava access_token, refresh_token,
// tenant_id, user_email, user_id, plano, tenant_nome e tenant_slug. Copiar
// esse conjunto aqui criaria uma segunda montagem de sessao para manter em
// sincronia, e a primeira chave esquecida seria um painel pela metade.
// Custa uma ida a mais ao servidor; vale.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE from "../config";
import { login } from "../store/auth";

// O plano que o teste concede. Tem de ser o MESMO que o PLANO_TRIAL do
// auth-service/src/routes/trial.py -- e ele que decide o que a pessoa
// recebe. Aqui so decide qual preco a tela mostra.
const PLANO = "premium";

// AUD-A1b -- o canal de volta.
//
// Numero do Abimael, nao o da oficina. Fica no fonte da pagina publica,
// como qualquer telefone comercial de site -- e proposital: quem quiser
// falar antes de se cadastrar tambem consegue.
const WHATSAPP_SUPORTE = "5511958325430";

function linkWhatsApp(oficina) {
  // A mensagem vai pronta e em nome de QUEM CLICA. Mensagem curta de
  // proposito: primeira mensagem longa de numero desconhecido vira
  // 'leio depois', e depois nao vem.
  const texto = "Ola Abimael! Acabei de criar minha conta de teste do SAAS.GL"
    + (oficina ? " para a oficina " + oficina : "")
    + ". Gostaria de agendar a configuracao.";
  return "https://wa.me/" + WHATSAPP_SUPORTE + "?text=" + encodeURIComponent(texto);
}

function avisarCliqueWhatsApp() {
  // Sem isto nao ha como saber se o convite funciona. Mesmo caminho do
  // evento de cadastro: dataLayer -> GTM -> Meta.
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "onboarding_whatsapp", lead_source: "comecar" });
  } catch {}
}

const COR = {
  fundo: "#0f172a", cartao: "#131929", borda: "#1e2a3a", campo: "#252d40",
  texto: "#f1f5f9", suave: "#94a3b8", fraco: "#64748b",
  acento: "#6366f1", acento2: "#3b82f6", ok: "#22c55e", erro: "#ef4444",
};

// Aceita numero OU texto: medido em producao em 27/10/2026, a chave
// "planos" guarda testeDias como "7" (texto) num plano e 0 (numero) nos
// outros. As duas formas convivem na mesma chave.
function num(bruto) {
  if (bruto === null || bruto === undefined || bruto === "") return null;
  const n = typeof bruto === "number" ? bruto : parseFloat(String(bruto).replace(",", "."));
  return isFinite(n) ? n : null;
}
function moeda(v) {
  const n = num(v);
  if (n === null) return null;
  return "R$ " + n.toFixed(2).replace(".", ",");
}

function Campo({ rotulo, dica, ...resto }) {
  return (
    <label style={{ display: "block", marginBottom: 14 }}>
      <span style={{ color: COR.suave, display: "block", fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
        {rotulo}
      </span>
      <input
        {...resto}
        style={{
          background: COR.campo, border: "1px solid " + COR.borda, borderRadius: 10,
          boxSizing: "border-box", color: COR.texto, fontFamily: "inherit", fontSize: 16,
          outline: "none", padding: "13px 14px", width: "100%",
        }}
      />
      {dica && <span style={{ color: COR.fraco, display: "block", fontSize: 11, marginTop: 4 }}>{dica}</span>}
    </label>
  );
}

// AUD-A1h (01/11/2026) -- campo de senha com olho magico.
//
// Separado do Campo generico de proposito: so a senha precisa disso, e
// o Campo e usado por mais tres campos que nao devem ganhar um botao.
function CampoSenha({ rotulo, dica, ...resto }) {
  // Comeca SEMPRE oculto. Mostrar por padrao expoe quem preenche com
  // alguem ao lado -- e o balcao de uma oficina e exatamente isso.
  const [visivel, setVisivel] = useState(false);
  return (
    <label style={{ display: "block", marginBottom: 14 }}>
      <span style={{ color: COR.suave, display: "block", fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
        {rotulo}
      </span>
      <span style={{ display: "block", position: "relative" }}>
        <input
          {...resto}
          type={visivel ? "text" : "password"}
          style={{
            background: COR.campo, border: "1px solid " + COR.borda, borderRadius: 10,
            boxSizing: "border-box", color: COR.texto, fontFamily: "inherit", fontSize: 16,
            outline: "none", padding: "13px 52px 13px 14px", width: "100%",
          }}
        />
        {/* type="button" e obrigatorio: dentro de um <form>, botao sem
            type vira submit e enviaria o cadastro ao clicar no olho. */}
        <button type="button" onClick={() => setVisivel(v => !v)}
                aria-label={visivel ? "Ocultar senha" : "Mostrar senha"}
                title={visivel ? "Ocultar senha" : "Mostrar senha"}
                style={{ alignItems: "center", background: "transparent", border: "none",
                         color: visivel ? COR.texto : COR.fraco, cursor: "pointer", display: "flex",
                         fontSize: 11, fontWeight: 700, height: "100%", justifyContent: "center",
                         letterSpacing: "0.5px", padding: "0 14px", position: "absolute",
                         right: 0, top: 0 }}>
          {visivel ? "OCULTAR" : "VER"}
        </button>
      </span>
      {dica && <span style={{ color: COR.fraco, display: "block", fontSize: 11, marginTop: 4 }}>{dica}</span>}
    </label>
  );
}

export default function Comecar() {
  const [lendoPreco, setLendoPreco] = useState(true);
  const [plano, setPlano] = useState(null);
  const [form, setForm] = useState({ oficina: "", email: "", whatsapp: "", senha: "" });
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState(null);       // { texto, mostrarLogin }
  // AUD-A1b (01/11/2026) -- guarda o nome da oficina recem-criada. Null
  // enquanto o formulario esta aberto; preenchido depois do cadastro, e
  // e isso que troca a tela pelo painel de boas-vindas.
  const [pronto, setPronto] = useState(null);
  const [origem] = useState(() => {
    try {
      const q = new URLSearchParams(window.location.search);
      return {
        utm_source: q.get("utm_source") || "",
        utm_medium: q.get("utm_medium") || "",
        utm_campaign: q.get("utm_campaign") || "",
        // utm_id: o Meta manda este, e ele NAO era capturado em lugar
        // nenhum do sistema -- sem ele a coluna de campanha no relatorio
        // fica vazia mesmo havendo campanha.
        utm_id: q.get("utm_id") || "",
        fbclid: q.get("fbclid") || "",
      };
    } catch { return { utm_source: "", utm_medium: "", utm_campaign: "", utm_id: "", fbclid: "" }; }
  });

  useEffect(() => {
    let vivo = true;
    fetch(API_BASE + "/api/v1/config/planos")
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("http"))))
      .then((d) => {
        if (!vivo) return;
        const lista = Array.isArray(d && d.value) ? d.value : [];
        const p = lista.find((x) => x && String(x.id).toLowerCase() === PLANO);
        // ativo === false esconde o plano da pagina publica (AUD-T2a).
        // Ausente conta como visivel, senao toda oficina gravada antes
        // daquele patch desapareceria daqui.
        setPlano(p && p.ativo !== false ? p : null);
      })
      .catch(() => { if (vivo) setPlano(null); })
      .finally(() => { if (vivo) setLendoPreco(false); });
    return () => { vivo = false; };
  }, []);

  const mensal = plano ? moeda(plano.preco) : null;
  const implantacao = plano ? num(plano.implantacao) : null;
  const dias = plano ? num(plano.testeDias) : null;
  const pm = plano ? num(plano.preco) : null;
  // O plano anual do SAAS.GL e "meses gratis", nao um preco cheio proprio:
  // o campo "Meses Gratis no Anual" (mesesDesc) ja existe na tela de
  // Configuracoes do painel. Paga-se (12 - mesesDesc) mensalidades pelo ano.
  // Fora da faixa 1..11 o anual simplesmente nao e oferecido -- 0 nao e
  // desconto, e 12 ou mais seria o ano inteiro de graca.
  const mesesGratis = (() => {
    const m = plano ? num(plano.mesesDesc) : null;
    if (m === null || m < 1 || m >= 12) return null;
    return Math.floor(m);
  })();
  const anual = pm && mesesGratis ? moeda(pm * (12 - mesesGratis)) : null;
  const recursos = plano && Array.isArray(plano.recursos) ? plano.recursos : [];

  const set = (c) => (e) => setForm((f) => ({ ...f, [c]: e.target.value }));

  function validar() {
    if (form.oficina.trim().length < 2) return "Escreva o nome da sua oficina.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) return "Confira o e-mail.";
    if (form.whatsapp.replace(/\D/g, "").length < 10) return "Confira o WhatsApp com DDD.";
    if (form.senha.length < 6) return "A senha precisa de 6 caracteres ou mais.";
    return null;
  }

  async function enviar(e) {
    e.preventDefault();
    if (enviando) return;
    const problema = validar();
    if (problema) { setErro({ texto: problema }); return; }
    setErro(null);
    setEnviando(true);
    const email = form.email.trim().toLowerCase();
    try {
      const r = await fetch(API_BASE + "/api/v1/trial/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          oficina: form.oficina.trim(),
          email: email,
          whatsapp: form.whatsapp.trim(),
          senha: form.senha,
          ...origem,
        }),
      });
      if (!r.ok) {
        // O detalhe do backend e escrito para ser lido por gente -- uso
        // ele quando vier, e caio num texto proprio quando nao vier.
        let detalhe = "";
        try { const c = await r.json(); detalhe = (c && c.detail) || ""; } catch {}
        if (r.status === 409) {
          setErro({ texto: detalhe || "Este e-mail ja tem conta.", mostrarLogin: true });
        } else if (r.status === 429) {
          setErro({ texto: detalhe || "Muitos cadastros deste acesso hoje. Tente mais tarde." });
        } else if (r.status === 400) {
          setErro({ texto: detalhe || "Use um e-mail permanente para criar sua conta." });
        } else if (r.status === 503) {
          setErro({ texto: detalhe || "O cadastro de teste esta indisponivel neste momento.", mostrarSuporte: true });
        } else {
          setErro({ texto: "Nao conseguimos criar sua conta agora. Tente de novo em instantes." });
        }
        setEnviando(false);
        return;
      }

      // A conversao sai SO depois do backend aceitar -- nunca antes. E o
      // mesmo criterio que a landing ja usa (LandingPage.js, depois do
      // r.ok). Para o Meta receber isto, o Pixel tem de estar montado
      // dentro do GTM e com um acionador para o evento "trial_signup".
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "trial_signup", lead_source: "comecar" });
      } catch {}

      // A sessao e montada pela login() de producao, nao aqui.
      await login(email, form.senha);
      // AUD-A1b -- NAO se joga mais a pessoa direto no painel.
      //
      // Medido em 30 e 31/10: quatro oficinas entraram pela campanha, o
      // unico login de cada uma foi o automatico daqui (18 a 37 segundos
      // apos o cadastro) e NENHUMA voltou nem criou um registro. O painel
      // comeca vazio -- grafico zerado, lista vazia, R$ 0,00 em tudo --
      // que e o oposto do que o anuncio mostrou.
      //
      // Aqui a pessoa ja esta logada: o botao 'Entrar' so completa o
      // caminho. O que muda e existir UM passo antes, com uma oferta de
      // ajuda humana em vez de uma tela em branco.
      // AUD-A1g: o e-mail JA NORMALIZADO vai junto. Tem de ser o mesmo
      // valor que o backend gravou -- mostrar na tela o texto cru que a
      // pessoa digitou seria mostrar um login que pode nao existir.
      setPronto({ nome: form.oficina.trim(), email: email });
      setEnviando(false);
    } catch (err) {
      // A conta pode ter sido criada e so o login ter falhado -- o proprio
      // endpoint devolve logado:false nesse caso. Mandar para o login e o
      // caminho honesto: as credenciais que a pessoa acabou de escolher
      // funcionam.
      setErro({
        texto: "Sua conta pode ter sido criada, mas nao conseguimos te conectar automaticamente.",
        mostrarLogin: true,
      });
      setEnviando(false);
    }
  }

  // ── AUD-A1b: o painel de boas-vindas ───────────────────────────────
  // Retorno antecipado, de proposito: o formulario ja cumpriu o papel e
  // nao deve continuar montado atras deste painel.
  if (pronto) {
    return (
      <div style={{ alignItems: "center", background: COR.fundo, display: "flex", justifyContent: "center", minHeight: "100vh", padding: "32px 16px" }}>
        <div style={{ maxWidth: 560, textAlign: "center", width: "100%" }}>

          <div style={{ color: COR.texto, fontSize: 30, fontWeight: 800, letterSpacing: "-0.5px" }}>
            SAAS<span style={{ color: COR.acento }}>.GL</span>
          </div>

          <div style={{ background: COR.cartao, border: "1px solid " + COR.borda, borderRadius: 16, marginTop: 28, padding: "36px 28px" }}>

            <div style={{ color: COR.ok, fontSize: 13, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
              Conta criada
            </div>

            <div style={{ color: COR.texto, fontSize: 25, fontWeight: 800, lineHeight: 1.25, marginTop: 10 }}>
              Sua oficina esta pronta, {pronto.nome}.
            </div>

            <div style={{ color: COR.suave, fontSize: 15, lineHeight: 1.6, marginTop: 14 }}>
              O sistema comeca vazio, e dar o primeiro passo sozinho da trabalho.
              Eu configuro com voce numa chamada rapida e deixo os dados da sua
              oficina rodando. Sem custo, e seu teste vale igual.
            </div>

            {/* AUD-A1g -- sem SMTP, ESTA TELA e o unico registro do
                acesso que a pessoa tem. Dai o pedido de guardar. */}
            <div style={{ background: COR.fundo, border: "1px solid " + COR.borda, borderRadius: 12, marginTop: 22, padding: "16px 18px", textAlign: "left" }}>
              <div style={{ color: COR.fraco, fontSize: 11, fontWeight: 700, letterSpacing: "1px", textTransform: "uppercase" }}>
                Guarde o seu acesso
              </div>
              <div style={{ color: COR.texto, fontSize: 15, fontWeight: 700, marginTop: 8, wordBreak: "break-all" }}>
                {pronto.email}
              </div>
              <div style={{ color: COR.suave, fontSize: 13, lineHeight: 1.55, marginTop: 8 }}>
                A senha e a que voce acabou de criar. Para voltar outro dia,
                entre em{" "}
                <span style={{ color: COR.texto, fontWeight: 600 }}>saas-gl.duckdns.org/login</span>.
              </div>
            </div>

            <a href={linkWhatsApp(pronto.nome)} target="_blank" rel="noreferrer"
               onClick={avisarCliqueWhatsApp}
               style={{ alignItems: "center", background: COR.ok, borderRadius: 10, color: "#06240f", display: "flex", fontSize: 16, fontWeight: 800, justifyContent: "center", marginTop: 26, padding: "15px 18px", textDecoration: "none" }}>
              Falar comigo no WhatsApp
            </a>

            <button type="button" onClick={() => window.location.replace("/")}
                    style={{ background: "transparent", border: "1px solid " + COR.borda, borderRadius: 10, color: COR.suave, cursor: "pointer", fontSize: 15, marginTop: 12, padding: "13px 18px", width: "100%" }}>
              Entrar no sistema agora
            </button>

          </div>

          <div style={{ color: COR.fraco, fontSize: 12, marginTop: 18 }}>
            Voce ja esta conectado. Pode entrar agora e falar comigo depois.
          </div>

        </div>
      </div>
    );
  }

  return (
    <div style={{ background: COR.fundo, minHeight: "100vh", padding: "32px 16px" }}>
      <div style={{ margin: "0 auto", maxWidth: 940 }}>

        <div style={{ marginBottom: 28, textAlign: "center" }}>
          <div style={{ color: COR.texto, fontSize: 30, fontWeight: 800, letterSpacing: "-0.5px" }}>
            SAAS<span style={{ color: COR.acento }}>.GL</span>
          </div>
          <div style={{ color: COR.fraco, fontSize: 12, letterSpacing: "1px", marginTop: 2, textTransform: "uppercase" }}>
            Gestao para oficinas
          </div>
        </div>

        <h1 style={{ color: COR.texto, fontSize: 27, fontWeight: 800, lineHeight: 1.25, margin: "0 0 10px", textAlign: "center" }}>
          Comece a usar agora,{dias ? " de graca por " + dias + " dias" : " sem compromisso"}
        </h1>
        <p style={{ color: COR.suave, fontSize: 15, lineHeight: 1.6, margin: "0 auto 30px", maxWidth: 560, textAlign: "center" }}>
          Preencha quatro campos e entre direto no sistema. Sem ligacao de vendas, sem
          esperar liberacao{dias ? ", sem cartao de credito" : ""}.
        </p>

        <div style={{ display: "flex", flexWrap: "wrap", gap: 24, justifyContent: "center" }}>

          {/* ---------------------------------------------- o formulario */}
          <form onSubmit={enviar} style={{
            background: COR.cartao, border: "1px solid " + COR.borda, borderRadius: 16,
            boxSizing: "border-box", flex: "1 1 360px", maxWidth: 440, padding: 26,
          }}>
            <Campo rotulo="Nome da oficina" value={form.oficina} onChange={set("oficina")}
              autoComplete="organization" placeholder="Mecanica Sao Jorge" />
            <Campo rotulo="Seu WhatsApp" value={form.whatsapp} onChange={set("whatsapp")}
              inputMode="tel" autoComplete="tel" placeholder="(11) 98888-7777" />
            <Campo rotulo="Seu e-mail" value={form.email} onChange={set("email")}
              type="email" inputMode="email" autoComplete="email" placeholder="voce@suaoficina.com.br" />
            <CampoSenha rotulo="Crie uma senha" value={form.senha} onChange={set("senha")}
              autoComplete="new-password" dica="No minimo 6 caracteres" />

            {erro && (
              <div style={{
                background: COR.erro + "22", border: "1px solid " + COR.erro, borderRadius: 10,
                color: "#fca5a5", fontSize: 13, lineHeight: 1.5, marginBottom: 14, padding: "11px 13px",
              }}>
                {erro.texto}
                {erro.mostrarLogin && (
                  <> <Link to="/login" style={{ color: "#fecaca", fontWeight: 700 }}>Entrar na minha conta</Link>.</>
                )}
                {erro.mostrarSuporte && (
                  <> <Link to="/" style={{ color: "#fecaca", fontWeight: 700 }}>Falar com a gente</Link>.</>
                )}
              </div>
            )}

            <button type="submit" disabled={enviando} style={{
              background: enviando ? COR.campo : "linear-gradient(135deg," + COR.acento + "," + COR.acento2 + ")",
              border: "none", borderRadius: 10, color: enviando ? COR.fraco : "#fff",
              cursor: enviando ? "default" : "pointer", fontFamily: "inherit", fontSize: 16,
              fontWeight: 700, padding: "14px", width: "100%",
            }}>
              {enviando ? "Criando sua conta..." : (dias ? "Comecar meus " + dias + " dias gratis" : "Criar minha conta")}
            </button>

            <p style={{ color: COR.fraco, fontSize: 11, lineHeight: 1.6, margin: "14px 0 0", textAlign: "center" }}>
              Ao criar a conta voce aceita os{" "}
              <Link to="/termos" style={{ color: COR.suave }}>Termos de Uso</Link>{" "}e a{" "}
              <Link to="/privacidade" style={{ color: COR.suave }}>Politica de Privacidade</Link>.
            </p>
            <p style={{ color: COR.fraco, fontSize: 12, margin: "12px 0 0", textAlign: "center" }}>
              Ja tem conta? <Link to="/login" style={{ color: COR.acento, fontWeight: 600 }}>Entrar</Link>
            </p>
          </form>

          {/* ---------------------------------------------- o preco */}
          <div style={{
            background: COR.cartao, border: "1px solid " + COR.borda, borderRadius: 16,
            boxSizing: "border-box", flex: "1 1 300px", maxWidth: 380, padding: 26,
          }}>
            {lendoPreco ? (
              <div style={{ color: COR.fraco, fontSize: 14, textAlign: "center" }}>Carregando...</div>
            ) : mensal ? (
              <>
                <div style={{ textAlign: "center" }}>
                  <div style={{ color: COR.texto, fontSize: 38, fontWeight: 800, letterSpacing: "-1px" }}>
                    {mensal}
                    <span style={{ color: COR.fraco, fontSize: 15, fontWeight: 400 }}>/mes</span>
                  </div>
                  {anual && (
                    <div style={{ color: COR.ok, fontSize: 13, fontWeight: 600, marginTop: 6 }}>
                      ou {anual}/ano — {mesesGratis} {mesesGratis === 1 ? "mes gratis" : "meses gratis"}
                    </div>
                  )}
                  <div style={{ color: implantacao ? COR.suave : COR.ok, fontSize: 12, marginTop: 8 }}>
                    {implantacao
                      ? "+ " + moeda(implantacao) + " de implantacao"
                      : "Sem taxa de implantacao"}
                  </div>
                  {dias > 0 && (
                    <div style={{
                      background: COR.acento + "22", borderRadius: 8, color: "#a5b4fc",
                      fontSize: 12, fontWeight: 700, marginTop: 12, padding: "7px 12px",
                    }}>
                      {dias} dias gratis — sem cartao de credito
                    </div>
                  )}
                </div>

                {recursos.length > 0 && (
                  <div style={{ marginTop: 22 }}>
                    <div style={{ color: COR.fraco, fontSize: 11, fontWeight: 600, letterSpacing: "0.06em", marginBottom: 10, textTransform: "uppercase" }}>
                      Tudo isto incluso
                    </div>
                    {recursos.map((r, i) => (
                      <div key={i} style={{ alignItems: "flex-start", display: "flex", gap: 8, marginBottom: 7 }}>
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={COR.ok}
                          strokeWidth="3" style={{ flexShrink: 0, marginTop: 3 }}>
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span style={{ color: COR.suave, fontSize: 13, lineHeight: 1.45 }}>{r}</span>
                      </div>
                    ))}
                  </div>
                )}

                <p style={{ color: COR.fraco, fontSize: 11, lineHeight: 1.6, marginBottom: 0, marginTop: 20 }}>
                  Cancele quando quiser, sem fidelidade. Qualquer mudanca de valor
                  e avisada com 30 dias de antecedencia —{" "}
                  <Link to="/termos" style={{ color: COR.suave }}>politica de preco</Link>.
                </p>
              </>
            ) : (
              /* Sem preco legivel na configuracao: NAO invento numero. */
              <div style={{ textAlign: "center" }}>
                <div style={{ color: COR.texto, fontSize: 22, fontWeight: 700 }}>Valor sob consulta</div>
                <p style={{ color: COR.suave, fontSize: 13, lineHeight: 1.6, marginTop: 10 }}>
                  Nao conseguimos carregar o valor agora. Voce pode criar sua conta de
                  teste do mesmo jeito, ou{" "}
                  <Link to="/" style={{ color: COR.acento, fontWeight: 600 }}>falar com a gente</Link>.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
